<!-- 上传实训导书/实训任务书组件 -->
<template>
  <section class="project-task-section">
    <div class="project-name-content">
      <div class="right-content-one">
        <p class="right-content-title">
          <span :title="Train.trainingName">项目名称：{{ Train.trainingName }}</span>
          <span @click="updateProject" v-if="teacherOrStudentState">修改</span>
        </p>
        <div class="right-content-information">
          <div class="information">
            <img :src="Train.photo ? photoBaseUrl + Train.photo : IconProfile" alt="" />
            <span :title="Train.createUserName">{{Train.createUserName}}</span>
            <span :title="Train.roleName">{{Train.roleName}}</span>
            <span :title="Train.orgsName">{{Train.orgsName}}</span>
          </div>
        </div>
        <div class="right-content-type">
          <span class="type">
            <span class="icon"></span>{{ trainingType }}
          </span>
          <span class="time">
            <span class="icons el-icon-time"></span>{{ Train.updateTime }}
          </span>
        </div>
      </div>
      <!-- 分割线 -->
      <div class="line"></div>
    </div>
    <!-- <div class="project-description">
      <em class="title">任务描述</em>
      <p class="text">{{ Train.trainingContent }}</p>
    </div> -->
    <div class="import-content-scroll">
      <div class="task-description">
        <p>项目描述：</p>
        <p>{{ Train.trainingContent }}</p>
      </div>
      <!-- 考核设置 -->
      <div class="import-section project-import-task project-import-guide-book">
        <p>考核设置：</p>
        <div class="import-wrap">
          <div class="pdf-wrap">
            <span v-if="Train.isAssess == 1" class="pdf-name">实训考核设置详情</span>
            <span v-else-if="teacherOrStudentState" class="pdf-btn btn2" @click="addTrainingAssessment()">{{withdrawReleaseStatus?'无实训考核设置':'添加实训考核'}}</span>
            <span v-else class="pdf-btn btn2">无实训考核设置</span>
          </div>
          <div class="func-wrap" v-if="Train.isAssess == 1">
            <span class="label" @click="seeTrainingAssessment()">查看</span>
            <span class="label" @click="deleteTrainingAssessment()" v-if="teacherOrStudentState ? !withdrawReleaseStatus : false">删除</span>
          </div>
        </div>
      </div>
      <!-- 实训任务书 -->
      <div class="import-section project-import-task project-import-guide-book">
        <!-- <em class="title">导入实训任务书：</em> -->
        <p>实训任务书：</p>
        <div class="import-wrap">
          <div class="pdf-wrap">
            <img
              v-if="Train.taskName"
              :src="iconPdf"
              class="pdf-btn"
              alt=""
              @click="upload('task')"
            />
            <span
              v-else-if="teacherOrStudentState"
              class="pdf-btn btn2"
              @click="upload('task')"
            >导入实训任务书</span>
            <span v-else class="pdf-btn btn2">暂无实训任务书</span>
            <span class="pdf-name">
              <span :title="Train.taskName">{{Train.taskName | splitName}}</span>
            </span>
          </div>
          <div class="func-wrap" v-if="Train.taskName">
            <span class="label" @click="viewTaskPdf('task')">查看</span>
            <span class="label" @click="deletePdf('task')" v-if="teacherOrStudentState">删除</span>
          </div>
        </div>
      </div>
      <!-- 实训实训指导书 -->
      <div class="import-section project-import-guide-book">
        <!-- <em class="title">导入实训指导书：</em> -->
        <p>实训指导书：</p>
        <div class="import-wrap">
          <div class="pdf-wrap">
            <img
              v-if="Train.guidanceName"
              :src="iconPdf"
              class="pdf-btn"
              alt=""
              @click="upload('guideBook')"
            />
            <span
              v-else-if="teacherOrStudentState"
              class="pdf-btn btn2"
              @click="upload('guideBook')"
            >导入实训指导书</span>
            <span v-else class="pdf-btn btn2">暂无实训指导书</span>
            <span class="pdf-name">
              <span :title="Train.guidanceName">{{Train.guidanceName | splitName}}</span>
            </span>
          </div>
          <div class="func-wrap" v-if="Train.guidanceName">
            <span class="label" @click="viewTaskPdf('guideBook')">查看</span>
            <span class="label" @click="deletePdf('guideBook')" v-if="teacherOrStudentState">删除</span>
          </div>
        </div>
      </div>
      <!-- 课程中的其它实训项目 -->
      <div class="import-section project-import-guide-book">
        <section class="other-training-section" v-if="!teacherOrStudentState">
          <p>课程中的其它实训项目:</p>
          <ul class="other-training-list">
            <li class="task-item" v-for="(item, index) of taskList" :key="index">
              <span class="name ellipsis" v-if="item.trainingId != trainingId" :title="item.trainingName">{{ item.trainingName }}</span>
              <span class="label" v-if="item.trainingId != trainingId" @click="otherTraining(item)">去完成</span>
            </li>
          </ul>
          <div class="pagination-wrap" v-if="taskList && taskList.length > 0">
            <p class="left-arror" @click="changeTraining(0)"><span></span></p>
            <p class="center">
              <span class="pageNum">{{ pagination.pageNum }}</span
              >/<span>{{ pagination.pageCount }}</span>
            </p>
            <p class="right-arror" @click="changeTraining(1)"><span></span></p>
          </div>
        </section>
      </div>
    </div>
    <div
      :class="{
        'pdf-view-content': true,
        'pdf-full-screen': isFullScreen,
        'pdf-normal-screen': !isFullScreen
      }"
      v-show="viewTask"
    >
      <header class="pdf-headr">
        <!-- pdf分页 -->
        <!-- <p class="arrow">
          <el-pagination
            small
            layout="prev, pager, next"
            :total="pdfObj.pageCount"
            :page-size="1"
            :current-page.sync="pdfObj.currentPage"
            @prev-click="changePdfPage(0)"
            @next-click="changePdfPage(1)"
            @current-change="getPdfPage"
          >
          </el-pagination>
        </p> -->
        <!-- 全屏/退出全屏按钮 -->
        <span
          class="full-screen"
          :title="
            isFullScreen
              ? Icons.ExitFullScreen.iconName
              : Icons.FullScreen.iconName
          "
          @click="fullScreen"
        >
          <icon-base
            class="icon-full-screen"
            :icon-name="Icons.FullScreen.iconName"
            v-bind="Icons.FullScreen"
            v-show="!isFullScreen"
          >
            <icon-full-screen />
          </icon-base>
          <icon-base
            class="icon-full-screen"
            :icon-name="Icons.ExitFullScreen.iconName"
            v-bind="Icons.ExitFullScreen"
            v-show="isFullScreen"
          >
            <icon-exit-full-screen />
          </icon-base>
        </span>
        <!-- 关闭 -->
        <span @click="pdfClose">
          <icon-base
            class="icon-close"
            :icon-name="Icons.PopupClose.iconName"
            v-bind="Icons.PopupClose"
          >
            <icon-popup-close />
          </icon-base>
        </span>
      </header>

      <div class="line"></div>
      <iframe class="iframe-pdf" :src="basePdfApi + pdfUrl" v-if="pdfUrl" width="100%" height="100%" frameborder="0"></iframe>
      <!-- <pdf
        :src="pdfUrl"
        :page="pdfObj.currentPage"
        @click="viewTask = false"
        @num-pages="pdfObj.pageCount = $event"
        @page-loaded="pdfObj.currentPage = $event"
        @loaded="loadPdfHandler"
      >
        >
      </pdf> -->
    </div>
    <div class="popup-list">
      <!-- 保存并提交 -->
      <gat-popup
        :class="['popup-submit-save', popupActive === 'update' ? 'on' : 'off']"
        :title="'编辑实训项目'"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="confirmUpdate"
      >
        <template v-slot:content>
          <el-form class="pop-el-form" ref="submitProject" :model="trainData" label-width="100px">
            <el-form-item label="项目名称：">
              <el-input 
                placeholder="请输入项目名称" 
                v-model.trim="trainData.trainingName" 
                maxlength="25"
                show-word-limit
              />
            </el-form-item>
            <el-form-item label="项目描述：">
              <el-input
                v-model.trim="trainData.trainingContent"
                type="textarea"
                placeholder="请输入项目描述"
                :rows="8"
                maxlength="200"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-form>
        </template>
      </gat-popup>
      <!-- 删除弹窗- 删除考核设置 -->
      <gat-popup
        :class="[
          'popup-delete popup-delete-2', popupActive === 'delete' ? 'on' :   'off',
        ]"
        :title="'提示'"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="onDeleteTrainingAssessment"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <!-- <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i> -->
              <!-- <span class="title"></span> -->
            </div>
            <div class="content">确定删除实训考核设置吗？</div>
          </div>
        </template>
      </gat-popup>

      <!-- 考核设置弹窗 -->
      <PopupAddAssessment
        ref="refTrainingAssessment"
        :modelType="modelType"
        :trainingId="trainingId"
        :teacherOrStudentState="teacherOrStudentState"
        :trainModelShow="trainModelShow"
        :withdrawReleaseStatus="withdrawReleaseStatus"
        @getTrainingByTrainingId="getTrainingByTrainingId"
      ></PopupAddAssessment>
    </div>
  </section>
</template>

<script>
import bus from "@/utils/bus";
// import pdf from "vue-pdf";
import MARKCENTER from '@/axios/trainingCenter/MarkCenter/MarkCenter.js'; // 项目标注接口
import PROJECTS from "@/axios/trainingCenter/projects/projects.js";
import COMMON from "@/axios/common/common.js";
import IconFullScreen from "@/components/icons/typography/FullScreen";
import IconExitFullScreen from "@/components/icons/typography/ExitFullScreen";
import IconPopupClose from "@/components/icons/typography/PopupClose";
import GatPopup from "@/components/common/GatPopup";
import PopupAddAssessment from "./PopupAddAssessment";

export default {
  name: "aiBookTaskTwo",
  //import引入的组件需要注入到对象中才能使用
  components: {
    // pdf,
    IconFullScreen,
    IconExitFullScreen,
    IconPopupClose,
    GatPopup,
    PopupAddAssessment,
  },
  props: {
    // 课程ID
    curriculumId: {
      type: String,
      default: ''
    },
    // 实训ID
    trainingId: {
      type: String,
      default: ''
    },
    // 实训详情
    Train: {
      type: Object,
      default() {
        return { taskUrl: "", guidanceUrl: "" };
      }
    },
    // true:老师， false:学生
    teacherOrStudentState: {
      type: Boolean,
      default: false
    },
    // 实训类型：1/3/5-(图片/文本/音频)分类，2-物体检测，4/6-(文本/音频)标注
    modelType: {
      type: String,
      default: '1'
    },
    // true：已发布模型，false:未发布模型
    trainModelShow: {
      type: Boolean,
      default: false,
    },
    // true:发布项目||发布项目后撤回，false:未发布项目
    withdrawReleaseStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 资源平台基地址
      basePdfApi: window.gtaAiConfig.basePdfApi, // pdfApi基地址配置
      pdfUrl: "", //需要查看的pdfUrl
      viewType: "task", //task为任务书,guideBook为指导书
      taskUrl: "", //任务书文档;
      guidanceUrl: "", //指导书文档;
      viewTask: false,
      viewGuideBook: false,
      pdfObj: {
        currentPage: 1, // pdf文件页码
        pageCount: 2, // pdf文件总页数
        fileType: "pdf" // 文件类型
      },
      fileType: "pdf", // 文件类型
      popupActive: "",
      trainData: {
        trainingName: '',
        trainingContent: '',
      },
      taskList: [],
      traningTypes: [], //实训编辑类型
      pagination: {
        pageNum: 1,
        pageSize: 4,
        total: null,
        pageCount: null,
      },
      Icons: {
        FullScreen: {
          iconName: "全屏",
          viewBox: "0 0 19 19",
          width: "19",
          height: "19"
        },
        ExitFullScreen: {
          iconName: "退出全屏",
          viewBox: "0 0 21 21",
          width: "21",
          height: "21"
        },
        PopupClose: {
          iconName: "关闭",
          viewBox: "0 0 14 14",
          width: "14",
          height: "14"
        }
      },
      isFullScreen: false,
      IconProfile: require("@/assets/images/ai-editor/profile03.png"),
      IconTime: require("@/assets/images/ai-editor/icon-time.png"),
      IconProjectQuestion2: require("@/assets/images/ai-editor/project-question2.png"),
      IconClassify: require("@/assets/images/ai-editor/icon-classify.png"),
      iconPdf: require("@/assets/images/ai-editor/PDF.png"),
    };
  },
  filters: {
    splitName: val => {
      let text;
      if (val && val.length > 8) {
        text = val.substring(0, 8) + "...";
      } else {
        text = val;
      }
      return text;
    }
  },
  //监控data中的数据变化
  watch: {
    trainingId: {
      handler(val) {
        console.log('trainingId==== ',val)
        // 学生查询其他实训列表数据
        if (!this.teacherOrStudentState) {
          this.getOtherTrainingByCurriculumId();
        }
      },
      deep: true,
      immediate: true
    },
    Train: {
      handler(val) {
        if (val) {
          this.trainData = JSON.parse(JSON.stringify(val))
        } else {
          this.trainData = {
            trainingName: '',
            trainingContent: '',
          }
        }
      },
      deep: true,
      immediate: true
    },
    "Train.taskUrl": {
      handler: function(val) {
        let taskUrl = val,
          new_service_data = window.new_service_data,
          reg = new RegExp(new_service_data),
          env = process.env.NODE_ENV;
        // if (val && env !== "production") {
        // }
        this.taskUrl = this.photoBaseUrl+ taskUrl;
      },
      immediate: true
    },
    "Train.guidanceUrl": {
      handler: function(val) {
        let guidanceUrl = val,
          new_service_data = window.new_service_data,
          reg = new RegExp(new_service_data),
          env = process.env.NODE_ENV;
        // if (val && env !== "production") {
        // }
        this.guidanceUrl = this.photoBaseUrl+guidanceUrl;
      },
      immediate: true
    }
  },
  //监听属性 类似于data概念
  computed: {
    trainingType() {
      let type = this.Train.type,
        val;
      val =
        type == 1
          ? "算法编程应用"
          : type == 2
          ? "智能硬件应用"
          : type == 3
          ? "数据标注应用"
          : "行业创研应用";
      return val;
    },
    // pdfUrl() {
    //   let viewType = this.viewType;

    //   if (viewType === "task") {
    //     // console.log('this.taskUrl', this.taskUrl)
    //     return this.taskUrl;
    //   } else {
    //     // console.log('this.guidanceUrl', this.guidanceUrl)
    //     return this.guidanceUrl;
    //   }
    // }
  },

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // this.taskFile = pdf.createLoadingTask(this.taskFile);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    bus.$on('addTrainingAssessment', (res) => {
      this.addTrainingAssessment(); // 添加实训考核
    })

    // 查询实训项目编辑方式
    this.getTrainingTypeApi();
  },
  beforeDestroy() {
    bus.$off('addTrainingAssessment')
  },
  methods: {
    /**
     *
     * 其他项目实训处理方法
     * */
    // 学生查询其它项目列表数据  @data curriculumId 课程id  pageNum pageSize trainingId
    async getOtherTrainingByCurriculumId() {
      let { pagination, curriculumId, trainingId } = this,
        data = {}
      data = {
        pageNum: pagination.pageNum,
        pageSize: pagination.pageSize,
        curriculumId,
        trainingId,
      }
      let res = await PROJECTS.getOtherTrainingByCurriculumId(data)
      if (res && res.isSuccess) {
        this.taskList = res.data.records || [];
        this.pagination.total = res.data.total
        this.pagination.pageCount = Math.ceil(
          res.data.total / this.pagination.pageSize
        )
      }
    },
    //跳转去其他实训
    async otherTraining(item) {
      if (!item) return

      // await bus.$emit('aiEditorSaveFile', 3) //触发保存代码
      // let res = await this.$parent.$parent.saveFile(3)

      if (item.type === 3) {
        // 数据标注
        if (item.status === 2 && this.teacherOrStudentState) {
          this.$router.push({
            name: 'training-model',
            query: {
              trainingId: item.trainingId,
              modelType: item.editorType,
            },
          })
        } else {
          this.$router.push({
            name: 'training-model',
            query: {
              curriculumId: item.curriculumId,
              trainingId: item.trainingId,
              modelType: item.editorType,
              userId: item.createBy,
            },
          }) // 标注页面
          this.$router.go(0);
        }
      } else {
        // 创建新任务
        this.redirectToProject(item)
      }
    },
    //实训-重定向到不同类别的编辑器
    redirectToProject(project) {
      let dictTypeDesc, queryName, path
      this.traningTypes.forEach((item) => {
        if (item.dictId == project.editorType) {
          dictTypeDesc = item.dictTypeDesc
        }
      })

      if (/(?=.*AI-T).*(?=.积木模式)/i.test(dictTypeDesc)) {
        queryName = 'training-editor-block'
        path = '/training/editor/block'
      } else if (/AI-T/i.test(dictTypeDesc)) {
        queryName = 'training-editor-ai-python'
        path = '/training/editor/ai/python'
      } else if (/海龟|基础/i.test(dictTypeDesc)) {
        queryName = 'training-editor-baseBlock'
        path = '/training/editor/baseBlock'
      }

      this.$router.push({
        name: queryName,
        query: {
          trainingId: project.trainingId,
          trainingName: project.trainingName,
          type: project.type,
          createBy: project.createBy,
          curriculumId: project.curriculumId,
          editorType: project.editorType,
          quoteTrainingId: project.quoteTrainingId,
        },
      })
      let pathname = window.location.pathname
      if (pathname === path) {
        this.$router.go(0)
      }
    },
    changeTraining(type) {
      if (type === 0) {
        if (this.pagination.pageNum !== 1) {
          this.pagination.pageNum--
          this.getOtherTrainingByCurriculumId()
        }
      } else {
        if (this.pagination.pageNum < this.pagination.pageCount) {
          this.pagination.pageNum++
          this.getOtherTrainingByCurriculumId()
        }
      }
    },
    // 查询实训项目编辑方式
    getTrainingTypeApi() {
      let data = {
        dictTypeCode: 'EditorType',
      }
      return PROJECTS.getTrainingType(data).then((res) => {
        if (res && res.returnCode == 200) {
          this.traningTypes = res.data
        }
      }).catch((err) => {
        console.log(err)
      })
    },

    // 父组件重新获取项目信息
    getTrainingByTrainingId() {
      this.$emit("getTrainingByTrainingId");
    },
    // 添加实训考核
    addTrainingAssessment() {
      if (this.withdrawReleaseStatus) { // 发布项目后或者发布后测回 无法再弹出设置考核
        return
      }
      this.seeTrainingAssessment().then(() => {
        this.$refs.refTrainingAssessment.addTrainingAssessment();
      });
    },
    // 查看实训考核
    seeTrainingAssessment() {
      return new Promise((resolve, reject) => {
        let data = {
          trainingId: this.trainingId // 实训id
        }
        if (this.teacherOrStudentState) { // 老师
          data.editorType = this.modelType // 类型
          MARKCENTER.getTrainingCheck(data).then(result => {
            if (result.isSuccess) {
              this.$refs.refTrainingAssessment.seeTrainingAssessment(result.data);
              resolve(result.data)
            } else {
              this.$message.error(result.returnMsg);
              reject(result)
            }
          });
        } else { // 学生
          MARKCENTER.getTrainingCheckByStudent(data).then(result => {
            if (result.isSuccess) {
              this.$refs.refTrainingAssessment.seeTrainingAssessment(result.data);
              resolve(result.data)
            } else {
              this.$message.error(result.returnMsg);
              reject(result)
            }
          });
        }
      })
    },
    // 删除实训考核
    deleteTrainingAssessment() {
      this.popupActive = 'delete';
    },
    // 确认删除实训考核
    onDeleteTrainingAssessment() {
      let data = {
        trainingId: this.trainingId // 实训id
      }
      MARKCENTER.deleteTrainingCheck(data).then(result => {
        if (result.isSuccess) {
          this.$emit("getTrainingByTrainingId"); //父组件重新获取项目信息
          this.cancelPopup();
          this.$message.success(result.returnMsg);
        } else {
          this.$message.error(result.returnMsg);
        }
      });
    },
    /**
     * 上传和删除pdf处理方法
     * */
    upload(fileType) {
      if (!this.teacherOrStudentState) {
        return;
      }
      let self = this;
      let inputNode = document.createElement("input");
      inputNode.setAttribute("type", "file");
      inputNode.setAttribute("accept", "application/*"); // 支持doc、ppt、xls、等文件的上传
      inputNode.setAttribute("multiple", "false"); //单文件上传
      inputNode.click();
      // 文件上传过程
      inputNode.onchange = async function uploadFile(evt) {
        // 获取 file
        let file = evt.target.files[0],
          fileList = evt.target.files,
          list = Array.from(fileList),
          formatPass,
          ppt_match = /.pdf/i;
        
        formatPass = self.$util.filesFormatEveryCheck(list, ppt_match)
        if (!formatPass) {
          return self.$message.error('上传失败，请上传PDF文件！')
        }

        const loading = self.$loading({
          lock: true,
          text: '上传中请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close(); // 超过60秒时关闭loading效果
        }, 1000*60);

        // 实例化
        var fileName = file.name;
        //截取名称长度
        fileName = fileName.slice(0, 10);

        let formdata = new FormData();
        formdata.append("file", file);
        let res = await COMMON.UploadFile(formdata);
        if (res && res.returnCode == 200) {
          self.$message({
            message: "上传成功！",
            type: "success",
            duration: 2000
          });
          let files = res.data,
            data,
            res2
            //  fileUrl = self.photoBaseUrl + files.url
            ;
          if (fileType == "task") {
            data = {
              trainingId: self.trainingId,
              taskUrl: files.url,
              taskName: files.fileName
            };
            //上传实训任务书接口
            res2 = await PROJECTS.uploadTrainingTask(data);
          } else if (fileType == "guideBook") {
            data = {
              trainingId: self.trainingId,
              guidanceUrl: files.url,
              guidanceName: files.fileName
            };
            // 上传实训实训指导书接口
            res2 = await PROJECTS.uploadTrainingGuidance(data);
          }

          if (res2 && res2.isSuccess) {
            self.$emit("getTrainingByTrainingId"); //父组件重新获取项目信息
          } else {
            self.$message.error("上传的文件保存失败！");
          }
          loading.close();
        } else {
          loading.close();
          self.$message.error("上传失败！");
        }
      };
    },
    //删除pdf文件
    async deletePdf(fileType) {
      let { trainingId } = this,
        { taskUrl, guidanceUrl } = this.Train,
        data = {},
        res;

      //调用删除接口
      if (fileType === "task") {
        data = { trainingId, taskUrl };
        res = await PROJECTS.deleteTrainingTask(data);
      } else {
        data = { trainingId, guidanceUrl };
        res = await PROJECTS.deleteTrainingGuidance(data);
      }

      if (res && res.isSuccess) {
        //初始化taskUrl 或 guidanceUrl
        if (fileType === "task") {
          this.taskUrl = "";
        } else {
          this.guidanceUrl = "";
        }
        this.$emit("getTrainingByTrainingId"); //父组件重新获取项目信息
        this.$message.success("删除成功");
      } else {
        this.$message.error("删除失败");
      }
    },
    /**
     *
     *
     * 项目修改处理方法
     * */
    updateProject() {
      this.trainData = JSON.parse(JSON.stringify(this.Train))
      this.popupActive = "update";
    },
    async confirmUpdate() {
      let { trainingName, trainingContent } = this.trainData;
      let { trainingId } = this;
      if (!trainingName || !trainingContent) {
        let msgName = trainingName ? '项目描述不能为空！' : '项目名称不能为空！'
        return this.$message.error(msgName);
      }
      let data = { trainingId, trainingName, trainingContent };
      let res = await PROJECTS.updateTraining(data);
      if (res && res.isSuccess) {
        this.$emit("getTrainingByTrainingId"); //父组件重新获取项目信息
        this.$message.success("修改成功！");
      } else {
        this.$message.error("修改失败！");
      }
      this.popupActive = "";
    },
    cancelPopup() {
      this.popupActive = "";
    },
    /**
     *
     *
     * pdf查看处理方法
     * */
    viewTaskPdf(viewType) {
      if (viewType == 'task' && !this.taskUrl || viewType == 'guideBook' && !this.guidanceUrl) {
        return this.$message.warning('没有文档')
      }
      if (viewType == 'task') {
        this.pdfUrl = this.taskUrl
      } else {
        this.pdfUrl = this.guidanceUrl
      }
      //和上一次查看的内容比较
      if (this.viewType !== viewType) {
        this.pdfObj.currentPage = 1;
      }
      this.viewTask = true;
      this.viewType = viewType;
    },
    fullScreen() {
      // TODO: 全屏操作
      this.isFullScreen = !this.isFullScreen;
      this.$emit('onIsFullScreen', this.isFullScreen)
    },
    pdfClose() {
      // TODO: 全屏操作
      this.isFullScreen = false;
      this.viewTask = false;
      this.viewGuideBook = false;
      this.$emit('onIsFullScreen', this.isFullScreen)
    },
    // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    changePdfPage(val) {
      if (val === 0 && this.pdfObj.currentPage > 1) {
        this.pdfObj.currentPage--;
      }
      if (val === 1 && this.pdfObj.currentPage < this.pdfObj.pageCount) {
        this.pdfObj.currentPage++;
      }
    },
    getPdfPage(val) {
      this.pdfObj.currentPage = val;
    },
    // pdf加载时
    loadPdfHandler(e) {
      this.pdfObj.currentPage = 1; // 加载的时候先加载第一页
    }
  }, // methods end
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.project-task-section {
  width: auto;
  height: 100%;
  padding: 0px 20px;
  color: #333333;
  .title {
    padding-top: 20px;
    color: #333333;
    font-size: 16px;
    font-family: "MicrosoftYaHei-Bold";
  }
  .label {
    font-size: 14px;
    color: #4c88ff;
    cursor: pointer;
    margin-left: 12px;
  }

  .project-name-content {
    width: 100%;

    .right-content-one {
      height: 136px;
      // margin: 0 20px;
      overflow: hidden;
      .right-content-title {
        width: 100%;
        height: 16px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        margin: 25px 0 23px;
        span:nth-child(1) {
          width: 260px;
          display: inline-block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        span:nth-child(2) {
          font-size: 14px;
          line-height: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #4c88ff;
          float: right;
          cursor: pointer;
        }
      }
      .right-content-information {
        width: 100%;
        display: flex;
        align-items: center;
        .information {
          width: 100%;
          font-size: 13px;
          display: flex;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            border-radius: 50%;
          }
          span {
            max-width: 65px;
            margin-left: 10px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            &:last-child {
              max-width: 100%;
              flex: 1;
            }
          }
        }
      }
      .right-content-type {
        height: 14px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        opacity: 0.6;
        line-height: 24px;
        margin-top: 15px;
        display: flex;
        .type {
          font-size: 13px;
          display: flex;
          margin-right: 27px;
          .icon {
            width: 10px;
            height: 12px;
            border: 1px solid #ffffff;
            background: url("../../../../assets/images/icon_classification.png")
              no-repeat;
            margin: 4px 10px 0 0;
            vertical-align: middle;
          }
        }
        .time {
          .icons {
            margin-right: 10px;
          }
        }
      }
    }

    .line {
      width: 300px;
      height: 1px;
      background: #e3e3e3;
      margin: 0 auto;
    }

    .header-wrap {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .name-text {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }
      .name-edit {
        padding-top: 20px;
        font-size: 14px;
        color: #4c88ff;
      }
    }
    .label-wrap {
      width: 100%;
      display: flex;
      justify-content: start;
      align-items: center;
      margin-top: 20px;
      font-size: 13px;
      color: #999;
      .classify {
        img {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          margin-right: 8px;
          vertical-align: bottom;
        }
        span {
          opacity: 0.6;
          // margin-left: 8px;
        }
      }
      .create-time {
        margin-left: 28px;
        span {
          opacity: 0.6;
          margin-left: 8px;
        }
      }
    }
    .el-divider {
      background-color: #253a76;
    }
  }

  .import-content-scroll {
    height: calc(100% - 150px);
    overflow-y: auto;
    padding-right: 5px;
    /* 设置滚动条的样式 */
    &::-webkit-scrollbar {
      width: 5px;
      box-shadow: inset006pxrgba(0, 0, 0, 0.7);
      -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.7);
    }
    /* 滚动槽 */
    &::-webkit-scrollbar-track {
      box-shadow: inset006pxrgba(0, 0, 0, 0.7);
      -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.7);
      border-radius: 5px;
    }
    /* 滚动条滑块 */
    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background: rgba(103, 140, 255, 0.5);
      box-shadow: inset006pxrgba(0, 0, 0, 0.7);
      -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.7);
    }
    &::-webkit-scrollbar-thumb:window-inactive {
      background: rgba(103, 140, 255, 0.5);
    }
  }

  .task-description {
    // width: 100%;
    display: flex;
    flex-direction: column;
    // margin-bottom: 30px;
    p:nth-child(1) {
      height: 13px;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      margin: 25px 0;
    }
    p:nth-child(2) {
      color: #666666;
      font-size: 14px;
      line-height: 24px;
      text-align: justify;
      text-justify: newspaper;
      word-break: break-all;
    }
  }

  .project-description {
    min-height: 100px;
    max-height: 240px;
    overflow: auto;
    padding-bottom: 20px;
    .text {
      color: #d0dcff;
      font-size: 14px;
      padding: 20px 0px;
    }
  }
  .import-section {
    p {
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
    }
    .import-wrap {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 18px;
      .pdf-wrap {
        display: flex;
        align-items: center;
        .pdf-btn {
          cursor: pointer;
        }
        .pdf-name {
          color: #9a7cff;
          font-size: 15px;
          margin-left: 13px;
        }
      }
    }
    &.project-import-guide-book {
      margin-top: 30px;
      .btn2 {
        display: inline-block;
        padding: 5px;
        font-size: 14px;
        background: rgba(154, 124, 255, 0.3);
        color: #c7b6ff;
        border-radius: 17px;
      }
    }
    .other-training-section {
    
      .other-training-list {
        width: 100%;
        color: #666;
        font-size: 15px;
        li {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin: 20px 0 0 0;
          .label {
            color: $bgc_btn_primary;
          }
          .name {
            flex: 1;
          }
        }
      }
      .pagination-wrap {
        background-color: none;
        background: none;
        text-align: right;
        display: flex;
        justify-content: center;
        margin-top: 20px;
        .center {
          margin: 0 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #4c88ff;
          font-size: 14px;
          .pageNum {
            color: #666;
          }
        }
        .left-arror,
        .right-arror {
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          width: 22px;
          height: 22px;
          background: $bgc_btn_primary;
          border-radius: 3px;
          cursor: pointer;
        }
        .left-arror {
          span {
            width: 0;
            height: 0;
            border-top: 4px solid transparent;
            border-right: 7px solid #fff;
            border-bottom: 4px solid transparent;
            display: inline-block;
          }
        }
        .right-arror {
          span {
            width: 0;
            height: 0;
            border-top: 4px solid transparent;
            border-left: 7px solid #fff;
            border-bottom: 4px solid transparent;
            display: inline-block;
          }
        }
      }
    }
  }
}
.pdf-view-content {
  width: 100%;
  height: 100%;
  background: #fff;
  .iframe-pdf {
    height: calc(100% - 40px);
  }
  &.pdf-normal-screen {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .pdf-headr {
      width: 100%;
    }
    .arrow {
      top: 7px;
      left: 10px;
      color: #666;
      position: absolute;
      width: 50%;
    }
    .full-screen {
      top: 10px;
    }
    .icon-close {
      top: 13px;
    }
  }
  &.pdf-full-screen {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    > span {
      position: absolute;
      width: 70%;
      height: auto;
      left: 50%;
      transform: translate(-50%, 0%);
    }
    .pdf-headr {
      width: 70%;
    }
    .arrow {
      padding-top: 10px;
    }
    .full-screen {
      top: 20px;
    }
    .icon-close {
      top: 23px;
    }
  }
  .line {
    width: 100%;
    border-bottom: 1px solid #ccc;
    margin-top: 5px;
  }
  .pdf-headr {
    min-height: 30px;
    height: 5%;
    display: flex;
    justify-content: center;
    align-items: center;
    .full-screen {
      display: inline-block;
      position: absolute;
      right: 30px;
      cursor: pointer;
      .icon-full-screen {
      }
    }
  }

  .icon-close {
    display: inline-block;
    position: absolute;
    right: 10px;
    top: 13px;
    cursor: pointer;
  }

  ::v-deep.el-icon-arrow-left:before,
  ::v-deep.el-icon-arrow-right:before {
    font-size: 20px;
  } 
}
.popup-list {
  .popup-submit-save {
    &.off {
      display: none;
    }
    &.on {
      display: inline-block;
    }
    &::v-deep .popup-inner {
      width: 580px;
      height: 100%;
      max-height: 48%;
      .popup-content {
        margin-top: 20px;
        .el-form {
          width: 96%;
          .el-form-item {
            margin-bottom: 20px;
          }
        }
        .score-text {
          margin-top: 20px;
        }
      }
    }
  }
  .popup-delete {
    &.off {
      display: none;
    }
    &::v-deep .popup-inner{
      width: 420px;
      height: 200px;
      .popup-content{
        font-size: 16px;
      }
      .popup-del-cnt {
        overflow: hidden;
        .head {
          .icon-box {
            display: inline-block;
            margin-right: 12px;
            vertical-align: middle;
          }
          .title {
            display: inline-block;
            color: #333;
            vertical-align: middle;
          }
        }
        .content {
          font-size: 16px;
          text-align: center;
          padding: 20px 0;
          margin-top: 25px;
        }
      }
    }
  }
}
</style>
